<template>
  <layout-workflow>
    <v-card flat>
      <v-card-title>
        <h6 class="title ml-2 pt-2">Account Settings</h6>
      </v-card-title>
      <v-card-text class="mr-0 pr-0 mt-0 pt-0" style="overflow-y: auto;">
        <v-layout column fill-height>
          <v-layout>
            <v-flex pl-5>
              <manage-account-profile-info :user="user" :org="org"></manage-account-profile-info>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card-text>
    </v-card>
  </layout-workflow>
</template>

<script>
import LayoutWorkflow from '@/components/layout/LayoutWorkflow'
import ManageAccountProfileInfo from '@/components/manage/ManageAccountProfileInfo'
import { MyActiveOrganization, MyUser } from '@/helpers/my-account-helper'

export default {
  components: { LayoutWorkflow, ManageAccountProfileInfo },
  data() {
    return {
      user: MyUser,
      org: MyActiveOrganization
    }
  }
}
</script>
